import { useLocation } from 'react-router-dom'
import { PageHeading } from 'app/components'
import { useT } from '_metronic/i18n/Metronici18n'
import { useEmpresaAtual } from '../../core/useEmpresaAtual'

/**
 * Cabeçalho da tela de valores, acima do <TableCard>: nome da instituição como título; CNPJ como
 * apoio. Enquanto a instituição carrega, usa o nome que veio na navegação (se houver).
 */
export const EmpresaHeading = () => {
  const empresa = useEmpresaAtual()
  const { state } = useLocation() as { state?: { nome?: string } }
  const { t } = useT()

  return (
    <PageHeading
      title={empresa?.nomeFantasia ?? state?.nome ?? `Carregando ${t('empresa.label.lowercase')}…`}
      description={empresa?.cnpj ? `CNPJ ${empresa.cnpj}` : undefined}
    />
  )
}
